import { render, staticRenderFns } from "./SCR_MBC_0115_02.vue?vue&type=template&id=0b86c9c9&scoped=true&"
import script from "./SCR_MBC_0115_02.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0115_02.vue?vue&type=script&lang=js&"
import style0 from "./SCR_MBC_0115_02.vue?vue&type=style&index=0&id=0b86c9c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86c9c9",
  null
  
)

export default component.exports